// extracted by mini-css-extract-plugin
export default {"root":"CandidateDocumentRequest_root__QxxUS","instructions":"CandidateDocumentRequest_instructions__iIxrU","error":"CandidateDocumentRequest_error__427WC"};